import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "~/css/AdminModal.css";
import { talkModes } from "~/Commons";
import { useAtom } from "jotai/index";
import { standbyModeAtom } from "~/Atom";

type AdminModalProps = {
  title?: string;
  isOpen: boolean;
  children: React.ReactNode;
};

const AdminModal: React.FC<AdminModalProps> = ({ title, isOpen, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [, setStandbyMode] = useAtom(standbyModeAtom);

  useEffect(() => {
    if (isOpen) {
      setStandbyMode(talkModes.stopped);
      setIsVisible(true);
      setAnimationClass("animate-in");
      return () => {};
    } else {
      setAnimationClass("animate-out");
      // アニメーション終わった後に非表示
      const timer = setTimeout(() => setIsVisible(false), 400);
      return () => clearTimeout(timer);
    }
  }, [isOpen, setStandbyMode]);

  if (!isVisible) return null;

  const adminModalContent = (
    <div className={"admin-modal-overlay"}>
      <div className={`admin-modal-base ${animationClass}`}>
        <div className="admin-modal-header font-default-bold-24">
          <h2>{title}</h2>
        </div>
        <div className="admin-modal-content">{children}</div>
      </div>
    </div>
  );

  // ポータルを使ってdocument.bodyに直接レンダリング
  return createPortal(adminModalContent, document.body);
};

export default AdminModal;
